import { IconClipboardText } from '@tabler/icons-react'

export const PERMISSION_SETS_RECORDS = {
  id: 'Records',
  description: 'Grant access to invite, create, edit, and delete records.',
  icon: IconClipboardText,
  sections: [
    {
      title: 'solicit',
      permissions: [
        {
          type: 'checkbox',
          label: 'Manage contact invites',
          children: [
            {
              type: 'checkbox',
              label: 'View invite and pending tabs',
            },
            {
              type: 'checkbox',
              label: 'Invite contacts to share records',
            },
            {
              type: 'checkbox',
              label: 'Disable and resend contact invites',
            },
            {
              type: 'checkbox',
              label: 'View referral context',
            },
            {
              type: 'checkbox',
              label: 'Accept and reject records',
            },
          ],
        },
      ],
    },
    {
      title: 'access',
      permissions: [
        {
          type: 'checkbox',
          label: 'Access to all location records',
        },
        {
          type: 'checkbox',
          label: 'Access only to records with these exclusive tags',
          description:
            'Note: anyone authorized to apply these exclusive tags can also grant record access to this permission set.',
        },
        {
          type: 'multiselect',
          label: 'Exclusive tags',
          withAsterisk: true,
          data: [
            { label: 'Tag 1', value: 'TAG_1' },
            { label: 'Tag 2', value: 'TAG_2' },
          ],
        },
      ],
    },
    {
      title: 'create',
      permissions: [
        {
          type: 'checkbox',
          label: 'Create contact records',
        },
        {
          type: 'checkbox',
          label: 'Create child records',
        },
      ],
    },
    {
      title: 'manage',
      permissions: [
        {
          type: 'checkbox',
          label: 'Allow bulk edits',
        },
        {
          type: 'checkbox',
          label: 'Send data check requests',
        },
        {
          type: 'checkbox',
          label: 'Send edit access requests',
        },
        {
          type: 'checkbox',
          label: 'Link records',
        },
        {
          type: 'checkbox',
          label: 'Edit relationships and roles',
        },
        {
          type: 'checkbox',
          label: 'Edit relationships and roles',
          info: 'Full access is required for this action.',
        },
      ],
    },
  ],
}
